import { gql } from '@apollo/client'

export default gql`
  mutation checkEligibility($input: CheckEligibilityInput!) {
    checkEligibility(input: $input) {
      eligible
      reason {
        code
        details {
          type
        }
      }
    }
  }
`
